module.exports = __webpack_public_path__ + "img/icon_赛事等级徽章_E级@3x.7cdf7463.png";